import {Component, OnInit} from '@angular/core';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {ActivatedRoute} from '@angular/router';
import {DigitalSignatureService} from '../service/digital-signature.service';

@Component({
  selector: 'app-digital-signature-rectangle-signed-document',
  templateUrl: './digital-signature-rectangle-signed-document.component.html',
  styleUrls: ['./digital-signature-rectangle-signed-document.component.scss']
})
export class DigitalSignatureRectangleSignedDocumentComponent implements OnInit {
  documentUUID?: string | null;
  public safePdfUrl?: SafeResourceUrl;

  constructor(private digitalSignatureService: DigitalSignatureService,
              private route: ActivatedRoute,
              private sanitizer: DomSanitizer) {
  }

  ngOnInit(): void {
    this.documentUUID = this.route.snapshot.paramMap.get('documentUUID');
    if (this.documentUUID) {
      this.getPdfSigned(this.documentUUID);
    }
  }

  getPdfSigned(documentUUID: string) {
    this.digitalSignatureService.getDocumentThatWillBeSigned(documentUUID).subscribe((response: ArrayBuffer) => {
      const blob = new Blob([response], {type: 'application/pdf'});
      this.safePdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(blob));

    }, error => {
      // todo: add error advise and some redirect
      console.error('There was an error:', error);
    });
  }
}
